import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center" }
const _hoisted_2 = { class: "fs-14 text-dark" }
const _hoisted_3 = {
  key: 0,
  class: "fs-14 pr-2"
}
const _hoisted_4 = { class: "btn-stripped d-flex align-items-center" }
const _hoisted_5 = { class: "btn-stripped d-flex align-items-center text-danger" }
const _hoisted_6 = { class: "btn-stripped d-flex align-items-center text-danger" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_ElDropdownItem = _resolveComponent("ElDropdownItem")
  const _component_ElDropdownMenu = _resolveComponent("ElDropdownMenu")
  const _component_ElDropdown = _resolveComponent("ElDropdown")

  return (_openBlock(), _createBlock("li", _hoisted_1, [
    _createVNode("span", {
      class: "list-bubbles mr-2",
      style: { opacity: _ctx.user.invitedEmail ? '.5' : '1' }
    }, [
      _createVNode(_component_Button, {
        class: "p-button-rounded p-button-sm p-button-secondary no-click",
        style: {"--size-bubble":"40px"}
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.userInitials), 1)
        ]),
        _: 1
      })
    ], 4),
    _createVNode("div", {
      style: { opacity: _ctx.user.invitedEmail ? '.5' : '1' },
      class: "d-flex flex-column align-items-center justify-content-between mr-auto"
    }, [
      _createVNode("span", _hoisted_2, _toDisplayString(_ctx.user.email ?? _ctx.user.invitedEmail), 1)
    ], 4),
    (_ctx.isOwner)
      ? (_openBlock(), _createBlock("span", _hoisted_3, _toDisplayString(_ctx.$t("AppResource.Owner")), 1))
      : (_ctx.isConfirmed)
        ? (_openBlock(), _createBlock(_component_ElDropdown, {
            key: 1,
            trigger: "hover",
            placement: "bottom-end",
            "popper-class": "el-dropdown__popper el-dropdown--context"
          }, {
            dropdown: _withCtx(() => [
              _createVNode(_component_ElDropdownMenu, { style: {"width":"240px"} }, {
                default: _withCtx(() => [
                  (_ctx.isMeTheOwner)
                    ? (_openBlock(), _createBlock(_component_ElDropdownItem, {
                        key: 0,
                        onClick: _withModifiers(_ctx.handleTransferOwnership, ["prevent","stop"])
                      }, {
                        default: _withCtx(() => [
                          _createVNode("button", _hoisted_4, _toDisplayString(_ctx.$t("AppResource.MakeOwner")), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_ElDropdownItem, {
                    onClick: _withModifiers(_ctx.handleDeleteSharingUser, ["prevent","stop"])
                  }, {
                    default: _withCtx(() => [
                      _createVNode("button", _hoisted_5, _toDisplayString(_ctx.$t("AppResource.Remove")), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Button, { class: "p-button-text p-button-sm" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("AppResource.Collaborator")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_ElDropdown, {
            key: 2,
            trigger: "hover",
            placement: "bottom-end",
            "popper-class": "el-dropdown__popper el-dropdown--context"
          }, {
            dropdown: _withCtx(() => [
              _createVNode(_component_ElDropdownMenu, { style: {"width":"240px"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_ElDropdownItem, {
                    onClick: _withModifiers(_ctx.handleDeleteSharingUser, ["prevent","stop"])
                  }, {
                    default: _withCtx(() => [
                      _createVNode("button", _hoisted_6, _toDisplayString(_ctx.$t("AppResource.Remove")), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Button, { class: "p-button-text p-button-sm" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("AppResource.InvitePending")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
  ]))
}